import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Sessao } from '../modelo/sessao';
import {SessaoService} from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';

declare var $ :any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends AbstractComponent implements OnInit {

  periodoDia: string;
  redirecionamento: boolean;
  nomeCompleto: string;
  primeiroNome: string;
  /**
   * Construtor padrão
   */
  constructor(
    private sessaoService: SessaoService,
    private router: Router) {
    super(sessaoService);
    this.redirecionamento = this.sessao.configuracaoVisual.redirecionar;
    // periodoDia
    if(new Date().getHours() < 12){
      this.periodoDia = "Bom dia";
    }
    else if(new Date().getHours() > 12 && new Date().getHours() < 18){
        this.periodoDia = "Boa Tarde";
    }
    else {
        this.periodoDia = "Boa Noite";
    }
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    this.nomeCompleto = this.sessao.autenticado.nmCliente;
    this.primeiroNome = this.nomeCompleto.substring(0, this.nomeCompleto.indexOf(' '));

    if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPad/i))) {
      $('.header').addClass('ios');
    }
  }


  /**
   * Efetua o logout do sistema
   */
  encerrarSessao = () => {
    if(this.redirecionamento){
      sessionStorage.removeItem("sessao");
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      this.router.navigate(['/redirecionamento']);
      let token = this.sessaoService.sessao.autenticado.nuCTRL;
      this.sessaoService.encerrarSessao(token).subscribe((result: Sessao) => result.configuracaoVisual.dsMsgemRetorno);
    } else{
      window.open('', '_self', '');
      window.close();
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      this.router.navigate(['/login-parceiro']);
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/header/header.component.ts